const indexToLetter = index => String.fromCharCode(index + 65);

export default indexToLetter;
